import { jsx as _jsx } from "react/jsx-runtime";
import { SignInFlow } from "@descope/react-sdk";
import { baseLanguage, useLanguage } from "@nxt-shared/i18n";
export function Login() {
    // Descope's flows carry base-language translations only.
    const locale = baseLanguage(useLanguage());
    return _jsx(SignInFlow, { locale: locale, onSuccess: (e) => {
            console.log(e);
        }, onError: (e) => console.log(e), redirectUrl: location.href });
}
//# sourceMappingURL=Login.js.map